import script from "./history-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./history-chart.vue?vue&type=script&lang=ts&setup=true"

import "./history-chart.vue?vue&type=style&index=0&id=1d1de066&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1de066"]])

export default __exports__